export default ({ user }) => user.permissions.can_switch_locale;
